import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function K({ callBuy }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);

    const cards: any = [
        {
            img: `/responsive/picture/power-independence/10_1`,
            power: t('secK_card1_power'),
            title: t('secK_card1_title'),
            desc: t('secK_card1_desc'),
            lists: [
                {
                    title: t('secK_card1_list1_title'),
                    desc: t('secK_card1_list1_desc'),
                },
                {
                    title: t('secK_card1_list2_title'),
                    desc: t('secK_card1_list2_desc'),
                },
                {
                    title: t('secK_card1_list3_title'),
                    desc: t('secK_card1_list3_desc'),
                },
                {
                    title: t('secK_card1_list4_title'),
                    desc: t('secK_card1_list4_desc'),
                },
            ],
            link_more: `https://${locale}.ecoflow.com/collections/power-kits`,
        },
        {
            img: `/responsive/picture/power-independence/10_2`,
            productImg: '/responsive/picture/common-products/400w.png',
            power: t('secK_card2_power'),
            title: t('secK_card2_title'),
            desc: t('secK_card2_desc'),
            lists: [
                {
                    title: t('secK_card2_list1_title'),
                    desc: t('secK_card2_list1_desc'),
                },
                {
                    title: t('secK_card2_list2_title'),
                    desc: t('secK_card2_list2_desc'),
                },
                {
                    title: t('secK_card2_list3_title'),
                    desc: t('secK_card2_list3_desc'),
                },
                {
                    title: t('secK_card2_list4_title'),
                    desc: t('secK_card2_list4_desc'),
                },
                {
                    title: t('secK_card2_list5_title'),
                    desc: t('secK_card2_list5_desc'),
                },
            ],
            link_more: `https://${locale}.ecoflow.com/products/400w-rigid-solar-panel`,
            productId: (() => {
                const localMap: any = {
                    de: '7898394657015',
                    fr: '7773575643362',
                    eu: '7346811961508',
                    uk: '7293362045120',
                    it: '7843558523121',
                    es: '7856793419998',
                };
                return localMap[locale] || localMap.de;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '43771006124279',
                    fr: '46898481922395',
                    eu: '46933291663703',
                    uk: '42914703114432',
                    it: '43419242135793',
                    es: '43593399828702',
                };
                return localMap[locale] || localMap.de;
            })(),
        },
    ];

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: card.title,
                position: `Power Independence Page_${card?.title}`,
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            callBuy({
                discountPrice: card?.discountPrice,
                originalPrice: card?.originalPrice,
                inventory: card?.inventory,
                productId: card?.productId,
                variantId: card?.variantId,
                img: card?.img,
                productImg: card?.productImg,
                title: card?.title,
            });
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    useEffect(() => {
        const tempArr = [...cards.filter((card: any) => card?.productId && card?.variantId)];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            if (!productId || !variantId) {
                return true;
            }
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        // tempArr[k].inventory = 1;
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item?.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardLists([cards[0], ...tempArr?.filter((list: any) => list?.inventory !== undefined)]);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="power-independence-K" className={`power-independence-K ${css['power-independence-K']}`}>
            <div className="ef-box">
                <Swiper className="cards swiper-box" effect="fade" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                    {cardLists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_375.jpg`} srcMobile={`${card?.img}_375.jpg`} alt={card?.title} />
                            <div className="card-info">
                                <p className="card-power">{card?.power}</p>
                                <p className="card-title">{card?.title}</p>
                                <p className="card-desc">{card?.desc}</p>
                                <ul className="card-lists">
                                    {card?.lists?.map((list: any) => (
                                        <li className="card-list" key={list?.title}>
                                            <p className="list-title">{list?.title}</p>
                                            <p className="list-desc">{list?.desc}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className={`card-btns ${card?.link_buy ? 'double' : ''}`}>
                                    {card?.link_buy && (
                                        <>
                                            {Number(card?.inventory) <= 0 ? (
                                                <button disabled className={`btn-buy card-btn disable`}>
                                                    {t('common_card_out')}
                                                </button>
                                            ) : (
                                                <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                    {t('common_card_buy')}
                                                </p>
                                            )}
                                        </>
                                    )}
                                    {card?.link_more && (
                                        <Link
                                            className="btn-more card-btn"
                                            href={`${card?.link_more}${
                                                String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                            }utm_source=scenario+page&utm_medium=Pillar`}
                                            target="_blank"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'buy',
                                                product_name: card.title.replace('\n', ' '),
                                                position: 'Product PreLaunch',
                                            }}
                                        >
                                            {t('common_card_more')}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
